import { createReducer, on } from '@ngrx/store';
import {
  loadOnboardingInfoListFailure,
  loadOnboardingInfoListSuccess,
  selectOnboardingInfoById,
  setCurrentOnboardingId,
  toggleLoadingStatus,
  setSelectedOnboardingInfo,
} from './onboarding-info.actions';
import { initialUIState } from './onboarding-info.state';

export const _uiReducer = createReducer(
  initialUIState,
  on(toggleLoadingStatus, (state, action) => ({
    ...state,
    isLoading: action.status,
  })),
  on(loadOnboardingInfoListFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(loadOnboardingInfoListSuccess, (state, action) => ({
    ...state,
    list: action.payload,
    isLoading: false,
    // If we have a currentOnboardingId, auto-select the matching item from the loaded list
    selected:
      state.currentOnboardingId != null
        ? action.payload.find((item) => item?.id === state.currentOnboardingId) || state.selected || null
        : state.selected,
  })),
  on(selectOnboardingInfoById, (state, { id }) => ({
    ...state,
    selected: state.list?.find((item) => item?.id === id) || null,
  })),
  on(setCurrentOnboardingId, (state, { id }) => ({
    ...state,
    currentOnboardingId: id,
    // If list is already present, select immediately; otherwise this will be handled on next load success
    selected: state.list?.length ? state.list.find((item) => item?.id === id) || null : state.selected,
  })),
  on(setSelectedOnboardingInfo, (state, { payload }) => ({
    ...state,
    selected: payload || null,
  })),
);

export function uiReducer(state: any, action: any) {
  return _uiReducer(state, action);
}
